import Vue from 'vue';
// 用于组件间通讯
const bars = new Vue();
export default bars;


// WEBPACK FOOTER //
// ./src/components/common/bars.js